import { InsightActionTypes, InsightState } from './insightTypes';

export const INIT_STATE: InsightState = {
  rawThought: '',
  distilledInsight: '',
  topic: '',
  toneTags: [],
  hook: '',
  pov: null,
  selectedAngle: null,
  insightId: null,
  exploreSessionId: null,
  isLoading: false,
  error: null,
};

const insightReducer = (state = INIT_STATE, action: any): InsightState => {
  switch (action.type) {

    case InsightActionTypes.DISTILL:
      return { ...state, isLoading: true, error: null };

    case InsightActionTypes.SELECT_ANGLE:
      return { ...state, selectedAngle: action.payload.angle };

    case InsightActionTypes.SET_EXPLORE_SESSION_ID:
      return { ...state, exploreSessionId: action.payload.sessionId };

    case InsightActionTypes.HYDRATE_FROM_EXPLORE:
      return {
        ...INIT_STATE,
        rawThought:        action.payload.rawThought,
        distilledInsight:  action.payload.distilledInsight,
        topic:             action.payload.topic,
        toneTags:          action.payload.toneTags,
        hook:              action.payload.hook,
      };

    case InsightActionTypes.HYDRATE_FROM_LIBRARY:
      return {
        ...INIT_STATE,
        rawThought:       action.payload.rawThought,
        distilledInsight: action.payload.distilledInsight,
        topic:            action.payload.topic,
        toneTags:         action.payload.toneTags,
        hook:             action.payload.hook,
        pov:              action.payload.pov,
        selectedAngle:    action.payload.selectedAngle,
        insightId:        action.payload.insightId,
      };

    case InsightActionTypes.CONFIRM_SAVE:
      return { ...state, insightId: action.payload.insightId };

    case InsightActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case InsightActionTypes.DISTILL:
          return {
            ...state,
            rawThought:       action.payload.data.rawThought,
            distilledInsight: action.payload.data.distilledInsight,
            topic:            action.payload.data.topic,
            toneTags:         action.payload.data.toneTags,
            hook:             action.payload.data.hook,
            pov:              action.payload.data.pov ?? null,
            isLoading:        false,
            error:            null,
          };
        default:
          return state;
      }

    case InsightActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case InsightActionTypes.DISTILL:
          return { ...state, isLoading: false, error: action.payload.error };
        default:
          return state;
      }

    case InsightActionTypes.RESET:
      return INIT_STATE;

    default:
      return state;
  }
};

export default insightReducer;
